import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, generatePath, useRouteMatch } from 'react-router-dom';
import { Breadcrumbs, Typography, useMediaQuery, useTheme } from '@mui/material';
import { useIntl } from 'react-intl';
import { Home as HomeIcon } from '@mui/icons-material';
import UserForm from '../components/UserForm';
import * as authService from '../services/auth';
import * as receiversActions from '../actions/receivers';
import { Roles } from '../models/roles';
import routes from '../routes';
import {
  StyledRescuerBreadcrumb,
  StyledRescuerTextBreadcrumb,
} from '../pages/rescuerDashboard/rescuerDashboardMobile/Components/StyledRescuerBreadcrumb';

const ReceiverStaffAddView = () => {
  const dispatch = useDispatch();
  const theme = useTheme();
  const isMobileView = useMediaQuery(theme.breakpoints.only('xs'));
  const match = useRouteMatch();
  const locations = useSelector(
    (state) => state.entities.receivers.locations.byReceiverId[match.params.receiverId] || []
  );
  const receivers = useSelector((state) => state.entities.receivers);
  const receiver = receivers.byId[match.params.receiverId];
  const receiverLocation = locations[0];
  const { formatMessage } = useIntl();

  useEffect(() => {
    dispatch(receiversActions.fetchReceiversIfNeeded());
  }, [dispatch]);

  const submitCallback = (data) =>
    dispatch(receiversActions.createReceiverStaff(receiver.id, receiverLocation.id, data));

  if (receivers.inflight || receiver === undefined) {
    return 'Loading Receiving Agency...';
  }

  const receiverPath = generatePath(routes.receiver, { id: receiver.id });
  const receiverMobilePath = generatePath(routes.index);

  return (
    <>
      {isMobileView ? (
        <Breadcrumbs aria-label="breadcrumb">
          <StyledRescuerBreadcrumb
            component={Link}
            to={generatePath(routes.mobileDashboard)}
            label={formatMessage({ id: 'breadcrumbs.home' })}
            icon={<HomeIcon style={{ color: '#fff' }} fontSize="small" />}
          />
          <StyledRescuerTextBreadcrumb
            component="a"
            href="#"
            label={formatMessage({ id: 'breadcrumbs.receiver-add-staff' })}
          />
        </Breadcrumbs>
      ) : (
        <Breadcrumbs sx={{ padding: 1 }} aria-label="Breadcrumbs">
          <Link color="inherit" to={routes.receivers}>
            Receiving Agencies
          </Link>

          <Link color="inherit" to={receiverPath}>
            {receiver.name}
          </Link>

          <Typography color="textPrimary">Add a Receiving Agency Staff</Typography>
        </Breadcrumbs>
      )}

      <UserForm
        showUserSelector
        redirectPath={isMobileView ? receiverMobilePath : receiverPath}
        submitCallback={submitCallback}
        showIsAdminCheckbox={authService.currentlyLoggedInOrImpersonatingUserHasAnyRoleInCurrentlySelectedSite([
          Roles.Admin,
          Roles.NationalSiteDirector,
          Roles.SiteDirector,
          Roles.ReceiverAdmin,
          Roles.ReceiverLocationAdmin,
        ])}
        isAdminCheckboxLabel="Is Receiving Agency Admin"
        showLocationFields={false}
        showEmployerFields={false}
        showQrtCheckbox={false}
        isMobileView={isMobileView}
        forceSendInvitation={isMobileView}
      />
    </>
  );
};

export default ReceiverStaffAddView;
